module.exports = __webpack_public_path__ + "static/media/collapse.b126e100.svg";